import { makeStyles } from '@mui/styles';
const drawerWidth = 230;

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    height: 'inherit',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    // boxShadow: 'none',
    backgroundColor: '#fff !important',
    height: 40,
    '& .MuiToolbar-root': {
      minHeight: 'unset',
      height: '100%',
      padding: '0px 12px',
    },

    "& .header-top": {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%'
    },

    "& .display-name": {
      background: '#EE602C',
      padding: '15px 0px',
      color: '#fff',
      
      "& h3,h4": {
        margin: 0,
        display: 'flex',
        justifyContent: 'center'
      }
    },

    '& .toolbar-mobile': {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
    display: 'flex',
    '& .head-left': {
      display: 'flex',
      height: '100%',
      width: 200,
      '& .logo-text': {
        fontWeight: 900,
        marginTop: 'auto',
        marginBottom: 'auto',
        color: '#333',
      },
      '& .f-div, & .s-div': {
        display: 'flex',
        '& p': {
          marginTop: 'auto',
          marginBottom: 'auto',
        },
      },
      '& .f-div': {
        borderRight: '1px solid #bebebe',
        paddingRight: 38,
        position: 'relative',
        '& .rotate': {
          backgroundColor: 'rgba(0,0,0,0.1)',
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: -12,
          right: 0
        },
      },
      '& .s-div': {
        paddingLeft: 12,
        '& p': {
          fontWeight: 700,
        },
      },
    },
    '& .head-right': {
      display: 'flex',
      justifyContent: "flex-end",
      width: 200,
      '& .profile': {
        marginLeft: theme.spacing(2),
        color: '#333',
      },
      "& .user-info": {
        display: "flex",
        "& .dis-name": {
          marginTop: "auto",
          marginBottom: "auto",
          marginRight: 8,
          color: "#234738",
          fontSize: '1rem'
        }
      }
    },
    '& .head-center': {
      flex: 1,
      display: "flex",

      "& > *": {
        margin: "auto",
        fontWeight: 900,
        fontFamily: "'Open Sans', sans-serif !important",
        letterSpacing: '0.1em'
      }
    }
  },
  appBarShift: {
    display: 'block'
  },
  menuButton: {
    marginRight: 10,
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    backgroundColor: 'rgba(0, 0, 0, 0)',
    overflowX: 'hidden',
    border: 0,
    zIndex: 1,

    "& .MuiPaper-root": {
      backgroundColor: "transparent",
      // borderRight: '2px solid rgba(0, 0, 0, 0.12)',
    },
    '& .MuiList-root': {
      padding: 0,
    },
    '& .icon': {
      color: '#fff',
    },
    '& .itm-text': {
      color: '#fff',
      '& .MuiTypography-root': {
        // whiteSpace: "break-spaces"
        fontSize: "0.98rem"
      },
    },
    '& .arrow-itm': {
      marginRight: 5,

      '& .MuiListItem-root': {
        padding: '8px 8px',

        '& .MuiListItemIcon-root': {
          minWidth: 'unset',
          marginRight: 8,
        },
      },
      "& .collap-arr": {
        "& .MuiListItemIcon-root": {
          marginRight: 0
        }

      },
      '& .open': {
        transform: 'rotate(180deg)',
        marginLeft: drawerWidth - 40,
        transition: theme.transitions.create(['transform', 'margin'], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
      },
      '& .close': {
        transform: 'rotate(0deg)',
        marginLeft: 0,
        transition: theme.transitions.create(['transform', 'margin'], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
      },
      "& .wrap-menu": {
        overflowY: "auto",
        overflowX: "hidden",
        maxHeight: "calc(100vh - 124px)",
        borderTop: '1px solid rgba(255,255,255,0.2)',

        "& .route-exp": {
          backgroundColor: "transparent",
          color: "#fff",
          boxShadow: "none",
          borderBottom: "1px solid rgba(255,255,255,0.2)",
          "& .Mui-expanded": {
            height: 48,
            minHeight: "unset",
          },
          "& .MuiAccordionSummary-content": {
            margin: 0,
            flex: 1,
            whiteSpace: "nowrap",
            overflow: "hidden",

            "& .MuiListItemIcon-root": {
              color: "#fff"
            }
          },
          "& .MuiAccordionSummary-expandIconWrapper": {
            color: "#fff",
            marginRight: 0,
            whiteSpace: "nowrap",
            overflow: "hidden",
            padding: 12,
          },
          "& .MuiAccordionSummary-root": {
            padding: 0
          },
          "& .MuiAccordionDetails-root": {
            padding: 0,
            "& .MuiList-root": {
              width: "100%"
            }
          },
          "& .MuiCollapse-container": {
            backgroundColor: "rgba(255,255,255,0.1)"
          }
        },
        "& .route-exp::before": {
          display: "none"
        },
        "& .Mui-expanded": {
          margin: 0,
        },
        "& .hide-exp-btn": {
          "& .MuiAccordionSummary-expandIconWrapper": {
            display: "none",
            // marginRight: "-48px !important"
          },
        },
      },
      "& .wrap-menu::-webkit-scrollbar-thumb": {
        backgroundColor: "rgba(255,255,255,0.5)",//theme.palette.primary.main
      },
      "& .wrap-menu-close::-webkit-scrollbar": {
        display: "none"
      }
    },
    '& .logo-cpn': {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      // color: '#fff',
      padding: 4,
      '& .wrap': {
        margin: 'auto',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        '& .divide': {
          height: '2px',
          backgroundColor: 'rgba(255,255,255,0.68)',
        },
      },
    },
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }) + " !important",
    overflowX: 'hidden',
    backgroundColor: '#2d353c',
    border: 0,
    '& .MuiList-root': {
      padding: 0,
    },
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }) + " !important",
    overflowX: 'hidden',
    width: 40,
    // [theme.breakpoints.up('sm')]: {
    //   width: theme.spacing(9) + 1,
    // },
    border: 0,
    backgroundColor: '#2d353c !important',
    '& .MuiList-root': {
      padding: 0,
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    // ...theme.mixins.toolbar,
    height: 40,
    minHeight: 'unset',
  },
  content: {
    flexGrow: 1,
    // padding: 8,
    // paddingLeft: 0,
    paddingTop: 8,
    // height: '100vh',
    overflow: 'hidden',
    backgroundColor: '#E9EDF0',
    color: '#fff',

    '& .main-paper': {
      // height: 'calc(100vh - 152px + 16px)',
      height: 'inherit',
      // padding: theme.spacing(1),
      // overflow: 'auto',
      position: 'relative',
      // overflow: 'hidden',
      marginTop: '30px',
      backgroundColor: '#E9EDF0',
      boxShadow: 'none'
    },
    '& .loading-main': {
      position: 'absolute',
      backgroundColor: 'rgba(0, 0, 0, 0.1)',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 9999,
    },
  },
  contentMobile: {
  },
  contentFull: {
    padding: theme.spacing(1),
    '& .main-box': {
      // padding: theme.spacing(1),
      height: 'calc(100vh - 40px - 16px)',
    },
  },
  rootProfileMenu: {
    '& .display-name': {
      '& .avatar-icon': {
        width: theme.spacing(6),
        height: theme.spacing(6),
        marginRight: theme.spacing(2),
      },
    },
    '& .menu-item': {
      '& .item-icon': {
        minWidth: 'unset',
        paddingRight: theme.spacing(1),
      },
    },
    '& .MuiList-root': {
      padding: 0,
    },
  },
  rootProfileMenuMobile: {
    '& .display-name': {
      '& .avatar-icon': {
        width: theme.spacing(3.5),
        height: theme.spacing(3.5),
        marginRight: theme.spacing(0.5),
      },
      '& .item-icon': {
        minWidth: 'unset',
        paddingRight: theme.spacing(1),
      },
    },
  }
}));
